import VendPackage from '../entities/VendPackage'
import FullServiceCustomerType from '../entities/FullServiceCustomerType'
export class PackageConfig {
    ID: number;
    PackageID?: number;
    VendPackage?: VendPackage;
    CustomerTypeID?: number;
    FullServiceCustomerType?: FullServiceCustomerType;
    PerformanceBasedPay?: boolean;
    CommissionRate?: number;
    MinimumVendPrice?: number;
}

export default PackageConfig;